import React from 'react';

import { NextLink } from 'apps/urban/components/NextLink/NextLink';

import { Body3 } from '../../../../components/Typography/Typography.style';
import { colors } from '../../../../styles/constants';
import { TNavigation } from '../../FooterV2.types';
import {
  FooterNavigationWrapper,
  FooterNavigationNav,
  FooterNavigationNavItem,
} from './FooterNavigationV2.style';

export const FooterNavigationV2 = ({ title, navigation }: TNavigation) => {
  return (
    <FooterNavigationWrapper>
      <Body3 color={colors.black}>{title}</Body3>
      <FooterNavigationNav>
        {navigation.map((item) => (
          <NextLink
            key={item._uid}
            href={
              item.item.cached_url.startsWith('http')
                ? item.item.cached_url
                : `/${item.item.cached_url}`
            }
          >
            <FooterNavigationNavItem color={colors.black}>{item.title}</FooterNavigationNavItem>
          </NextLink>
        ))}
      </FooterNavigationNav>
    </FooterNavigationWrapper>
  );
};
